import React, { useRef, useEffect, useState } from 'react';
import { Container, Wrapper } from './style';
import Resume from '../../components/Resume';
import Headings from '../../components/Headings';
import KnowledgeLevel from '../../components/KnowledgeLevel';
export default function ResumePage() {
  const myRef = useRef();
  const [knowledgeLevelIsVisible, setKnowledgeLevelIsVisible] = useState();
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setKnowledgeLevelIsVisible(entry.isIntersecting);
    });
    observer.observe(myRef.current);
  }, []);
  return (
    <Container>
      <Wrapper resume>
        <Resume />
      </Wrapper>
      <Wrapper heading>
        <Headings
          number={'01'}
          title={'professional'}
          status={'my knowledge level in software'}
        />
      </Wrapper>
      <Wrapper ref={myRef}>
        {knowledgeLevelIsVisible && <KnowledgeLevel />}
      </Wrapper>
    </Container>
  );
}
